export default "__VITE_ASSET__Dwr8HxQe__"